function takaisin() {
    window.history.back();
}

jQuery('.menu-item-has-children').each(function(){
    jQuery(this).children('a:first').replaceWith(function() {
      return '<span class="wannabea" tabindex="0">' + jQuery(this).text() + '</span>'
    });
});

jQuery('#main-navigation .menu-item-has-children').click(function() {
    jQuery('.navigation--mega.open').each(function(){
        jQuery(this).removeClass('open');
    });
    jQuery('.header__megamenu.open').each(function(){
        jQuery(this).removeClass('open');
    });
    let isThisOpen = jQuery(this).hasClass('open');
    jQuery('#main-navigation .menu-item-has-children.open').each(function() {
      jQuery(this).removeClass('open');
    });
    if ( !isThisOpen ) {
      jQuery(this).toggleClass('open');
    }
});

function toggleMainNav() {
    if(jQuery('#mobile-navigation').hasClass('open')) {
        hideClose();
    } else {
        jQuery('#mobile-navigation').toggleClass('open');
        jQuery('#main-nav-toggle').toggleClass('hide');
        jQuery('.header__toggle-close').toggleClass('open');
        jQuery('body').toggleClass('no-scroll');
    }
}

function hideClose() {
    jQuery('body').removeClass('no-scroll');
    jQuery('#mobile-navigation').removeClass('open');
    jQuery('#main-nav-toggle').removeClass('hide');
    jQuery('.header__toggle-close').removeClass('open');
}

jQuery( document ).ready( function() {
    jQuery('#mobile-navigation .menu-item-has-children span').addClass('menu-closed');
    menuClick();
});

function menuClick() {
    jQuery('#mobile-navigation .menu-item-has-children .menu-closed').click(function(event) {
        jQuery( event.target ).addClass('menu-open');
        jQuery( event.target ).parent().addClass('open');
        jQuery( event.target ).removeClass('menu-closed');
        jQuery( '#mobile-navigation' ).scrollTop(0);
        jQuery( '#mobile-navigation' ).addClass('menu-no-scroll');
        
        jQuery('#mobile-navigation .menu-item-has-children.open .menu-open').on('click', function() {
            handleSubMenu();
        });
    });
}

function handleSubMenu() {
    jQuery('#mobile-navigation .menu-item-has-children.open span').addClass('menu-closed');
    jQuery('#mobile-navigation .menu-item-has-children.open .menu-open').removeClass('menu-open');
    jQuery('#mobile-navigation .menu-item-has-children.open').removeClass('open');
    jQuery('#mobile-navigation').removeClass('menu-no-scroll');
    menuClick();
}

function openMegamenu(menu) {
    jQuery('#main-navigation .menu-item-has-children.open').each(function() {
        jQuery(this).removeClass('open');
    });

    jQuery('#mega-navigation').toggleClass('open');
    jQuery('#megamenu-' + menu).toggleClass('open');
    jQuery('.header__lajipalkinnot-toggle').toggleClass('open');
}

function openMobilemegamenu(ele) {
    jQuery(ele).toggleClass('open');
    jQuery('#mobilemegamenu').toggleClass('open');
}
